export const API_URL = `https://forkify-api.jonas.io/api/v2/recipes`;
export const TIMEOUT_SECONDS = 10;
export const RES_PER_PAGE = 10;
// export const MODAL_
export const KEY = `52226d5e-4a0f-48a5-9a8d-44d4f85cdbe7`;

export const MODAL_CLOSE_SEC = 2.5;
